import { Button, Checkbox, Divider, Flex, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getFavoriteMerchantId, setFavoriteMerchantId } from '~/helpers/cookies';
import useModalNavigation from '~/hooks/useModalNavigation';
import { ACTIVE_MERCHANT_UPDATE, USER_LOGOUT } from '~/store/reducers/session';

import AdsSettings from './MerchantSettings/AdsSettings';
import PromotionsSettings from './MerchantSettings/PromotionsSettings';
import SpellcheckSettings from './MerchantSettings/SpellcheckSettings';
import TemplateEditor from './MerchantSettings/TemplateEditor';
import TemplatesList from './MerchantSettings/TemplatesList';
import TemplatesSettings from './MerchantSettings/TemplatesSettings';

function MyAccount({ activeMerchant, merchants, dispatch }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFavoriteMerchant, setIsFavoriteMerchant] = useState(getFavoriteMerchantId() === activeMerchant.id);
  const nav = useModalNavigation('main');

  useEffect(() => {
    setIsFavoriteMerchant(getFavoriteMerchantId() === activeMerchant.id);
  }, [activeMerchant]);

  const merchantsCleaned = merchants.filter((merchant) => merchant.id !== activeMerchant.id);
  const merchantOptions = merchantsCleaned.map((merchant) => ({
    value: merchant.id,
    label: merchant.name,
    slug: merchant.slug,
  }));

  const deconnectUser = () => {
    dispatch({ type: USER_LOGOUT });
    setIsModalOpen(false);
  };

  const changeMerchant = (idMerchant) => {
    dispatch({
      type: ACTIVE_MERCHANT_UPDATE,
      payload: { merchant_id: idMerchant },
    });
  };

  const onChangeFavoriteMerchant = () => {
    setIsFavoriteMerchant(!isFavoriteMerchant);
    if (isFavoriteMerchant) {
      setFavoriteMerchantId(null);
    } else {
      setFavoriteMerchantId(activeMerchant.id);
    }
  };

  const filterOption = (input, option) => {
    const name = option?.label ?? '';
    const slug = option?.slug ?? '';
    const id = option?.value ?? '';

    return name.toLowerCase().includes(input.toLowerCase()) || slug.toLowerCase().includes(input.toLowerCase()) || id.includes(input);
  };

  return (
    <>
      <a
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <span className='body1'>Mon compte</span>
      </a>
      <Modal
        centered
        open={isModalOpen}
        footer={null}
        closeIcon={null}
        onCancel={() => {
          setIsModalOpen(false);
          nav.reset();
        }}
        className='w-full min-w-[70%]'
      >
        {nav.current.view === 'main' && (
          <>
            <h2 className='h2 h-[62px] flex items-center mt-[-16px]'>Mon compte</h2>
            <Flex vertical gap={24} className='pt-l overflow-y-auto max-h-[80vh]'>
              <div className='bg-creme-background rounded-md p-m grid grid-cols-1 sm:grid-cols-2 gap-l'>
                {merchantOptions.length > 0 && (
                  <Flex vertical gap={16}>
                    <Flex vertical gap={8}>
                      <p className='caption2'>Boutique</p>
                      <Select
                        size='large'
                        listHeight={200}
                        showSearch
                        value={activeMerchant.name}
                        onChange={changeMerchant}
                        options={merchantOptions}
                        filterOption={filterOption}
                      />
                    </Flex>
                    <Flex gap={8} align='center'>
                      <Checkbox checked={isFavoriteMerchant} onChange={onChangeFavoriteMerchant}>
                        Définir comme marchand favoris
                      </Checkbox>
                    </Flex>
                  </Flex>
                )}
                <Flex vertical gap={8}>
                  <p className='caption2'>À propos</p>
                  <p className='body1 flex items-center gap-s'>
                    <span className='text-grey-medium'>Nom :</span>
                    <span>{activeMerchant.name}</span>
                  </p>
                  <p className='body1 flex items-center gap-s'>
                    <span className='text-grey-medium'>Id marchand :</span>
                    <span>{activeMerchant.id}</span>
                  </p>
                </Flex>
              </div>
              <p className='sub1'>Paramètres généraux</p>

              <Flex vertical gap={8}>
                <SpellcheckSettings />
                <Divider />

                <AdsSettings />
                <Divider />

                <TemplatesSettings onOpen={() => nav.push('templatesList')} />
                <Divider />

                <PromotionsSettings />
                <Divider />
              </Flex>
              <Button block onClick={deconnectUser} type='link' className='self-center'>
                <span className='!font-normal'>Déconnexion</span>
              </Button>
            </Flex>
          </>
        )}

        {nav.current.view === 'templatesList' && (
          <TemplatesList activeMerchantId={activeMerchant.id} onBack={nav.pop} onSelect={(template) => nav.push('templateEditor', { template })} />
        )}

        {nav.current.view === 'templateEditor' && (
          <TemplateEditor activeMerchantId={activeMerchant.id} template={nav.current.props.template} onBack={nav.pop} />
        )}
      </Modal>
    </>
  );
}

export default connect((state) => ({
  activeMerchant: state.session.active_merchant,
  merchants: state.session.user.merchants,
}))(MyAccount);
